export default __webpack_public_path__ + "static/media/StarGold.059932c3.svg";